module.exports = __webpack_public_path__ + "img/4.bbd78a4b.png";